module.exports = __webpack_public_path__ + "static/media/05660011-TASzwSgs.6b505763.JPG";